import React, { useRef } from "react";
import Badges from "../Badges/Badges";
import Options from "../Options/Options";
import Picture from "../Picture/Picture";
import Prices from "../Prices/Prices";
import ShippingTime from "../ShippingTime/ShippingTime";
import ActionButton from "../ActionButton/ActionButton";
import "./Hit.scss";
import InwerkProductAward from "../InwerkProductAward/InwerkProductAward";

// Get hit attribute from config file

const Hit = (props) => {
    const hitRef = useRef(null);
    const {hit} = props;
    const maxBadgeAmount = hit.detail_hide_product_badges === 1 ? 0 : 2;

    let articleUrl = hit.url;

    articleUrl += (hit.url.includes("?")) ? "&" : "?"
    articleUrl += "queryID=" + hit.__queryID

    return (
        <div
            className="search-hit"
            ref={hitRef}
            data-insights-object-id={hit.objectID}
            data-insights-position={hit.__position}
            data-insights-query-id={hit.__queryID}
        >
            <a
                className="search-hit__link"
                href={articleUrl}
            >
                <div className="search-hit__image-container">
                    <Picture hit={hit}/>
                    <Badges hit={hit} maxBadges={maxBadgeAmount}/>
                    <div className="product-awards-algolia">
                        {hit.inwerk_product_awards ? hit.inwerk_product_awards.map((item, index) => (
                            <InwerkProductAward productAward={item} index={index}/>
                        )) : null}
                    </div>
                </div>
                <div className="search-hit__content">
                    <div className="search-hit__name">{hit.name}</div>
                    <div className="search-hit__options-price">
                        <Options
                            configurableMeasurements={hit.detail_configurableMeasurements}
                            configurableColor={hit.detail_configurableColor}
                            configurableOthers={hit.detail_configurableOthers}
                        ></Options>
                        <Prices hit={hit}/>
                    </div>
                    <ShippingTime
                        shippingTimeInDays={hit.detail_shippingTimeInDays}
                        shippingFree={hit.detail_shippingPrices.DE === 0}
                    />
                    <ActionButton hit={hit}/>
                </div>
            </a>
        </div>
    );
};

export default Hit;
